export default __webpack_public_path__ + "bad722669ffa2c99fd8aed1d28416710.png";